import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Tipo Movimento',
  path: '/merenda/mertipomovimento',
  name: 'mertipomovimento',
  component: () => import('@/views/merenda/mertipomovimento/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEMOVIMENTONOVO_MENU_1000600950],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Tipo Movimento',
  path: '/merenda/mertipomovimento/cadastro/:id?',
  parent: 'mertipomovimento',
  name: 'mertipomovimento_create',
  component: () => import('@/views/merenda/mertipomovimento/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEMOVIMENTONOVO_MENU_1000600950],
  },
  goesToMenu: true,
 },
]
